export default "__VITE_ASSET___SjaKlnd__"